import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { filterByDate, filterByDistance } from 'tennders-stracture/libs/map'
import { apiPost } from 'tennders-stracture/libs/api'
import { REDUX_PROMPT_TYPES } from 'tennders-common/stores/prompt/action'

const useMatchLoads = () => {
  const dispatch = useDispatch()
  const [range, setrange] = useState(5000)
  const [dateRange, setdateRange] = useState(-1)
  const [loads, setloads] = useState([])
  const [loading, setloading] = useState(false)
  const [allItems, setallItems] = useState([])

  const { transaction } = useSelector((state) => state.prompt.loadToMatch)

  const matchLoad = (transaction) => dispatch({
    type: REDUX_PROMPT_TYPES.MATCH_LOADS,
    payload: transaction
  })

  const filter = (unfilteredItems) => {
    let items = filterByDistance(transaction?.pickupRoute?.location, [...unfilteredItems], range)
    if (dateRange !== false && `${dateRange}` !== '-1' && dateRange !== 'all') {
      items = filterByDate(transaction?.dayDiff, [...items])
    }

    setloads(items)
  }

  const fetchLoads = async (transactionId) => {
    setloading(true)
    const response = await apiPost('loads/to-match', { transaction: transactionId })
    if (response?.items) {
      setallItems(response?.items)

      filter([...response?.items], range)
    }
    setloading(false)
  }

  useEffect(() => {
    filter(allItems)
  }, [range, dateRange])

  return {
    loading,
    range,
    setrange,
    dateRange,
    setdateRange,
    fetchLoads,
    loads,
    matchLoad,
    loadToMatch: transaction
  }
}

export default useMatchLoads
